
export default function Values() {
  const partnerLogos = [
    { name: 'Integrity',  path: '/integrity.png' },
    { name: 'Impact',     path: '/impact.png' },
    { name: 'Fun',        path: '/fun.png' },
    { name: 'Attitude',   path: '/attitude.png' },
    { name: 'Simplicity', path: '/simplicity.png' },
    { name: 'Teamwork',   path: '/teamwork.png' },
  ];

  return (
    <>
      <section style={{ marginTop: 10, marginBottom: 60 }}>
        <div className="container-fluid text-center">
          <div className="carousel-container position-relative overflow-hidden">
            <div className="carousel-track d-flex">
              {partnerLogos.map((partner, idx) => (
                <div
                  key={`first-${idx}`}
                  className="partner-logo d-flex align-items-center justify-content-center flex-shrink-0"
                >
                  <img
                    src={partner.path}
                    alt={partner.name}
                    className="img-fluid"
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </div>
              ))}

              {partnerLogos.map((partner, idx) => (
                <div
                  key={`second-${idx}`}
                  className="partner-logo d-flex align-items-center justify-content-center flex-shrink-0"
                >
                  <img
                    src={partner.path}
                    alt={partner.name}
                    className="img-fluid"
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .carousel-container {
          width: 100%;
          mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
        }

        .carousel-track {
          gap: 20px;
          width: fit-content;
          animation: scroll 20s linear infinite;
        }

        .carousel-track:hover {
          animation-play-state: paused;
        }

        @keyframes scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .partner-logo {
          width: 180px;
          height: 80px;
          transition: all 0.3s ease;
        }

        .partner-logo:hover {
          filter: grayscale(0%) opacity(1);
          transform: scale(1.1);
        }
      `}</style>
    </>
  );
}
